import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import React, { useContext, useState } from 'react'
import moment from 'moment'
import AnDateField from '../../../../components/DateTime/DateField'
import { DetailRow } from '../../../../components/Cards/DetailsBox'
import API from '../../../../services/API'
import { GlobalContext, UserContext } from '../../../../App'

const SafeguardingReview = ({
  Concerns,
  setOpenManagerReview,
  epcrID,
  setRecord,
  safeguarding,
  setMenuAnchorEl,
}) => {
  const [notes, setNotes] = useState(safeguarding?.managerReview?.notes ?? '')
  const [referralTo, setReferralTo] = useState(
    safeguarding?.managerReview?.referralTo ?? ''
  )
  const [followUpRequired, setFollowUpRequired] = useState(
    safeguarding?.managerReview?.followUpRequired ?? false
  )
  const [followUpDetails, setFollowUpDetails] = useState(
    safeguarding?.managerReview?.followUpDetails ?? ''
  )
  const [followUpDate, setFollowUpDate] = useState(
    safeguarding?.managerReview?.followUpDate
      ? moment(safeguarding.managerReview.followUpDate)
      : null
  )

  const { user } = useContext(UserContext)
  const { setToast } = useContext(GlobalContext)

  const handleSubmit = (e) => {
    e.preventDefault()
    API.put(`/epcr/${epcrID}`, {
      'safeguarding.managerReview': {
        actionedDate: new Date(),
        reviewedBy: user._id,
        notes,
        referralTo,
        followUpRequired,
        followUpDetails,
        followUpDate,
        followUpComplete: false,
      },
    }).then((res) => {
      if (res.status === 200) {
        API.post('/epcr/clinicaladvice', {
          epcr: epcrID,
          note: 'Safeguarding Concerns Reviewed',
          showInRecord: false,
        })
        setRecord((prev) => ({
          ...prev,
          safeguarding: {
            ...prev.safeguarding,
            managerReview: {
              actionedDate: new Date(),
              reviewedBy: {
                firstName: user.firstName,
                lastName: user.lastName,
                _id: user._id,
              },
              notes,
              referralTo,
              followUpRequired,
              followUpDetails,
              followUpDate,
              followUpComplete: false,
            },
          },
        }))
        setToast({ message: 'Record Updated' })
        setOpenManagerReview(false)
        setMenuAnchorEl(null)
      } else {
        setToast({
          message: 'Unable to update record. Please try again later.',
          severity: 'error',
        })
      }
    })
  }

  return (
    <Stack gap={1} component="form" onSubmit={handleSubmit}>
      <Typography variant="title2">Safeguarding Concerns</Typography>
      {Concerns.map((c, index) => (
        <DetailRow key={index} label={c.label} value={c.value} />
      ))}
      {setRecord && (
        <>
          <Typography variant="title3">Manager / DSL Review</Typography>
          <TextField
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            label="Notes"
            helperText="Additional Notes or Actions taken by the manager"
            multiline
            minRows={3}
          />
          <TextField
            value={referralTo}
            onChange={(e) => setReferralTo(e.target.value)}
            label="Referral To"
            helperText="Write the Name/Address as you wish it to appear on the letter."
            multiline
            minRows={3}
          />
          <FormControlLabel
            label="Follow Up Required"
            control={
              <Checkbox
                checked={followUpRequired}
                onChange={(e) => setFollowUpRequired(e.target.checked)}
              />
            }
          />
          {followUpRequired && (
            <>
              <TextField
                value={followUpDetails}
                onChange={(e) => setFollowUpDetails(e.target.value)}
                label="Follow up Details"
              />
              <AnDateField
                value={followUpDate}
                onChange={(newDate) => setFollowUpDate(newDate)}
                label="Follow up Date"
              />
            </>
          )}
          <Button
            type="button"
            variant="outlined"
            color="error"
            onClick={() => setOpenManagerReview(false)}
          >
            Cancel
          </Button>
          <Button type="submit" variant="contained" color="success">
            Submit
          </Button>
        </>
      )}
    </Stack>
  )
}

export default SafeguardingReview
